import _ from "lodash";
import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import Settings from "./routes/Settings";
import PortfolioSetup from "Administrator/routes/Settings/routes/PortfolioManager/routes/PortfolioSetup";
import ActivitySettings from "Administrator/routes/Settings/routes/PortfolioManager/routes/ActivitySettings";
import ReviewerSetup from "Administrator/routes/Settings/routes/PortfolioManager/routes/ReviewerSetup";
import { getNextMenuRoute } from "Administrator/modules/AdministratorModule";
import { getRelativePath } from "Utils";
export default store => ({
  path: "portfolio-manager",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "admin-portfolio-manager" */ "./components"),
      import(
        /* webpackChunkName: "admin-portfolio-manager" */ "./modules/PortfolioManagerModule"
      ),
      import(
        /* webpackChunkName: "admin-portfolio-manager" */ "./routes/TeacherPortfolio/modules/TeacherPortfolioModule"
      ),
      import(
        /* webpackChunkName: "admin-portfolio-manager" */ "./routes/ReviewerSetup/modules/ReviewerSetupModule"
      ),
    ])
      .then(
        ([
          importedModule0,
          importedModule1,
          importedModule2,
          importedModule3,
        ]) => {
          const component = importedModule0.default;
          const reducer = importedModule1.default;
          const teacherPortfolio = importedModule2.default;
          const reviewerSetup = importedModule3.default;
          injectReducer(store, {
            key: "portfolioManager",
            reducer,
          });
          injectReducer(store, {
            key: "teacherPortfolio",
            reducer: teacherPortfolio,
          });
          injectReducer(store, {
            key: "reviewerSetup",
            reducer: reviewerSetup,
          });
          return component;
        }
      )
      .catch(err => {
        return err;
      })
  ),
  onEnter(nextState, replace) {
    if (_.last(nextState.routes).path == "portfolio-manager") {
      const route = getNextMenuRoute("PORTFOLIO_MANAGER");
      if (route) {
        replace(getRelativePath(route));
      } else {
        replace(getRelativePath("../"));
      }
    }
  },
  childRoutes: [
    PortfolioSetup(store),
    ActivitySettings(store),
    Settings(store),
    ReviewerSetup(store),
  ],
});
